import 'whatwg-fetch';

const ERROR_RESPONSE_REGEX = /(?=([45][0-9]))\d{3}/;
const isErrorResponse = status => ERROR_RESPONSE_REGEX.test(status);

export function post(url, body, onErrorResponse = () => {}) {
  const authToken = document.querySelector("meta[name='csrf-token']").content;

  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': authToken,
    },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  }).then((response) => {
    if (isErrorResponse(response.status)) {
      onErrorResponse(response);
    }

    return response.json().then(json => (response.ok ? json : Promise.reject(json)));
  });
}

export function get(url) {
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
  }).then(response => response.json().then(json => (response.ok ? json : Promise.reject(json))));
}

export function patch(url, body) {
  const authToken = document.querySelector("meta[name='csrf-token']").content;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': authToken,
    },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  }).then(response => response.json().then(json => (response.ok ? json : Promise.reject(json))));
}


export function put(url, body) {
  const authToken = document.querySelector("meta[name='csrf-token']").content;
  return fetch(url, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': authToken,
    },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  }).then(response => response.json().then(json => (response.ok ? json : Promise.reject(json))));
}

export default {
  post,
  get,
  patch,
  put,
};
